export default __webpack_public_path__ + "static/media/stop.28d7dcf5.svg";